import Spacer from '$tablet-app/src/app/components/Spacer';
import Text from '$tablet-app/src/app/components/Text';
import { color, palette } from '$tablet-app/src/app/theme';
import React, { FC } from 'react';
import styled from 'styled-components/native';

interface Props {
  label: string;
  emoji: string;
  selected?: boolean;

  onPress: (label: string) => void;
}

const ContactTagButton: FC<Props> = (props) => {
  const { label, emoji, selected, onPress } = props;

  return (
    <FilterButton onPress={() => onPress(label)} active={selected}>
      <Text>{emoji}</Text>
      <Spacer width="10px" />
      <FilterText weight="bold" active={selected}>
        {label}
      </FilterText>
    </FilterButton>
  );
};

const FilterButton = styled.TouchableOpacity<{ active?: boolean }>`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-radius: 20px;
  background-color: ${(props) =>
    props.active ? palette.Pale_blue : palette.lightGrey1};
  padding-horizontal: 16px;

  height: 38px;
`;

const FilterText = styled(Text)<{ active?: boolean }>`
  color: ${(props) => (props.active ? palette.primary_70 : color.text)};
`;

export default ContactTagButton;
